export default __webpack_public_path__ + "static/media/app-poster-hard-launch-ams.49fbe522.jpg";